import { Theme } from '@mui/material/styles';
import LinkBehavior from '@/components/LinkBehavior';

export default function Link(theme: Theme) {
  return {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
  };
}
